import React, { useEffect, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { useAppDispatch, useAppSelector } from '../store/store';
import Modal from '../Components/Modal';
import TextField from '../Components/TextField';
import { Question, MultipleChoice, MultipleSelection } from '../types';
import { MdAddBox } from 'react-icons/md';
import { addQuestion, updateQuestion } from '../store/features/CreateSurveySlice';
import { addSurveyQuestion, updateSurveyQuestion } from '../Firebase/utils';

export default ({ ...props }) => {

    const user = useAppSelector(state => state.user.user);
    const survey = useAppSelector(state => state.survey.survey);
    const dispatch = useAppDispatch();
    const [question, setQuestion] = useState<Question>(props.question || {
        id: uuidv4(),
        questionText: '',
        type: 'Multiple Selection',
        questionBody: {
            options: []
        } as MultipleSelection
    });
    const [option, setOption] = useState<string>('');

    console.log(survey);

    const handleAddOption = (option: string) => {
        const updatedOptions = [...(question.questionBody as MultipleSelection).options, option];
        setQuestion({
            ...question,
            questionBody: {
                ...question.questionBody,
                options: updatedOptions
            } as MultipleChoice
        });
        setOption('');
    };

    const handleRemoveOption = (optionToRemove: string) => {
        const updatedOptions = (question.questionBody as MultipleSelection).options.filter(opt => opt !== optionToRemove);
        setQuestion({
            ...question,
            questionBody: {
                ...question.questionBody,
                options: updatedOptions
            } as MultipleSelection
        });
    };

    const handleDelete = async () => {
        try{
            console.log('Deleting...');
            await addSurveyQuestion(user, survey, question);
            dispatch(addQuestion({question, response: { questionId: question.id, questionText:question.questionText, questionType:question.type, results:[] }}));
            props.onClose();
        }catch(err){
            alert(err);
        }
    };

    const handleUpdate = async () => {
        try{
            console.log('Updating...');
            await updateSurveyQuestion(user, survey, question);
            dispatch(updateQuestion(question));
            props.onClose();
        }catch(err){
            alert(err);
        }
    };

    const handleSubmit = () => {
        if(question.questionText === ''){
            alert('Question cannot be empty');
            return;
        }
        if((question.questionBody as MultipleSelection).options.length < 2){
            alert('Please add at least 2 options');
            return;
        }
        if(props.question){
            handleUpdate();
        }else{
            handleDelete();
        }
    };

    return (
        <Modal title='Multiple Selection Form' styles='gap-4' openState={props.openState} onClose={() => { props.onClose(undefined) }}>
            <div className='flex flex-col gap-6 md:gap-10'>
                <TextField placeholder={'Question'} inputValue={question.questionText} setInputValue={(e) => setQuestion({ ...question, questionText: e })} />
                <div className='grid grid-cols-12'>
                    <TextField styles={'col-span-11'} placeholder={'Option'} inputValue={option} setInputValue={setOption} />
                    <button className='' onClick={() => handleAddOption(option)}><MdAddBox className='' /></button>
                </div>
                <div className='flex flex-col gap-5'>
                    {(question.questionBody as MultipleSelection).options.map((option: string) => {
                        return (
                            <div className='flex gap-5' key={option}>
                                <p>{option}</p>
                                <button onClick={() => handleRemoveOption(option)}>Remove</button>
                            </div>
                        );
                    })}
                </div>
            </div>
            <button onClick={() => { handleSubmit() }} className='w-full bg-[#3da8e2] text-white p-2 rounded-md border-[#8dd2f6] border shadow-black shadow-lg font-BardotBold tracking-widest'>{props.question ? 'Update Question' : 'Add Question'}</button>
        </Modal>
    );
};